import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import components
import Footer from './components/Footer';

// Import pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import ArtistsPage from './pages/ArtistsPage';
import FAQPage from './pages/FAQPage';
import LegalPrivacyPage from './pages/LegalPrivacyPage';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButtonGreen';
function App() {
  if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/videoCache.js')
      .then(registration => console.log('Service Worker registered'))
      .catch(error => console.log('Service Worker registration failed:', error));
  });
}
  return (
    <Router>
     
       <ScrollToTop /> 
      <div className="App">
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/artists" element={<ArtistsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/legal-privacy" element={<LegalPrivacyPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
       
      <ScrollToTopButton />
    </Router>
  );
}

export default App;